(function () {
  const configNode = document.getElementById('cf-cone-config');
  if (!configNode || window.cfConeIntegrity) return;
  const config = JSON.parse(configNode.textContent);
  const coneId = String(config.variantId || '');
  const root = window.Shopify?.routes?.root || '/';
  const bypassForms = new WeakSet();
  let busy = false;
  let needsCartRefresh = false;

  function missingCones(items) {
    const yarns = new Map();
    items.forEach(function (item) {
      if (String(item.product_type || '').trim().toLowerCase() === 'cone' && Number(item.quantity) > 0) {
        yarns.set(String(item.variant_id), item);
      }
    });
    const covered = new Set();
    items.forEach(function (item) {
      if (String(item.variant_id) !== coneId || Number(item.quantity) <= 0) return;
      const parent = String(item.properties?._linked_id || '');
      if (yarns.has(parent)) covered.add(parent);
    });
    const additions = [];
    yarns.forEach(function (item, id) {
      if (covered.has(id)) return;
      const title = item.product_title || item.title || '';
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      additions.push({
        id: coneId,
        quantity: 1,
        properties: { _linked_id: id, 'For yarn': [title, variant].filter(Boolean).join(', ') }
      });
    });
    return additions;
  }

  function showMessage(text) {
    const drawer = document.querySelector('cart-drawer');
    const host = !document.body.classList.contains('template-cart') && drawer
      ? drawer.querySelector('.drawer__inner')
      : document.getElementById('main-cart-footer') || document.querySelector('main');
    if (!host) return;
    let message = document.getElementById('cf-cone-check-message');
    if (!message) {
      message = document.createElement('p');
      message.id = 'cf-cone-check-message';
      message.setAttribute('role', 'alert');
      message.style.cssText = 'padding:12px;margin:12px 0;border-radius:8px;background:#eef1d9;color:#34471f;line-height:1.4';
      host.prepend(message);
    }
    message.textContent = text;
  }

  async function waitForCartUpdates() {
    const deadline = Date.now() + 10000;
    while (window.cfCartAddsPending > 0 || window.cfCartUpdatesPending > 0) {
      if (Date.now() >= deadline) throw new Error('Cart update did not finish');
      await new Promise(resolve => setTimeout(resolve, 50));
    }
  }

  async function cartRequest(path, body) {
    const options = body ? {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    } : { cache: 'no-store' };
    const response = await fetch(root + path, options);
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || 'Unable to verify winding cones');
    return data;
  }

  async function checkCart() {
    if (needsCartRefresh) throw new Error('Refresh the cart to review the updated total');
    await waitForCartUpdates();
    const cart = await cartRequest('cart.js');
    const additions = missingCones(cart.items || []);
    if (!additions.length) return true;
    if (!coneId) throw new Error('Winding cone is not configured');
    window.cfCartAddsPending = (window.cfCartAddsPending || 0) + 1;
    try {
      needsCartRefresh = true;
      const data = await cartRequest('cart/add.js', {
        items: additions,
        sections: ['cart-drawer', 'cart-icon-bubble', 'main-cart-items', 'main-cart-footer'],
        sections_url: window.location.pathname
      });
      const verified = await cartRequest('cart.js');
      if (missingCones(verified.items || []).length) throw new Error('Some yarns still need linked winding cones');
      needsCartRefresh = true;
      const drawer = document.querySelector('cart-drawer');
      if (drawer && !document.body.classList.contains('template-cart') && data.sections?.['cart-drawer']) {
        drawer.renderContents(data);
      } else {
        const items = document.querySelector('cart-items');
        const footer = document.getElementById('main-cart-footer');
        if (!items || !footer || !data.sections?.['main-cart-items'] || !data.sections?.['main-cart-footer']) {
          throw new Error('Unable to show the updated cart');
        }
        const parser = new DOMParser();
        const sourceItems = parser.parseFromString(data.sections['main-cart-items'], 'text/html').querySelector('cart-items');
        const sourceFooter = parser.parseFromString(data.sections['main-cart-footer'], 'text/html').getElementById('main-cart-footer');
        if (!sourceItems || !sourceFooter) throw new Error('Updated cart sections are missing');
        items.innerHTML = sourceItems.innerHTML;
        footer.innerHTML = sourceFooter.innerHTML;
      }
      needsCartRefresh = false;
      showMessage(config.repaired);
      return false;
    } finally {
      window.cfCartAddsPending = Math.max(0, (window.cfCartAddsPending || 1) - 1);
      window.dispatchEvent(new CustomEvent('cartChanged'));
    }
  }

  function isCheckout(url) {
    if (!url) return false;
    try {
      const target = new URL(url, window.location.origin);
      return target.origin === window.location.origin && /\/checkout\/?$/.test(target.pathname);
    } catch (_) {
      return false;
    }
  }

  async function validateAndContinue(proceed) {
    if (busy) return;
    busy = true;
    const region = document.querySelector('cart-drawer.active .drawer__inner') || document.querySelector('main');
    const wasInert = region?.inert || false;
    if (region) region.inert = true;
    let allowed = false;
    try {
      allowed = await checkCart();
    } catch (error) {
      console.error('Winding cone validation failed', error);
      showMessage(config.failed);
    } finally {
      busy = false;
      if (region) region.inert = wasInert;
    }
    if (allowed) proceed();
  }

  document.addEventListener('submit', function (event) {
    const form = event.target;
    if (bypassForms.has(form)) {
      bypassForms.delete(form);
      return;
    }
    const button = event.submitter;
    const target = button?.getAttribute('formaction') || form.getAttribute('action');
    if (button?.name !== 'checkout' && !isCheckout(target)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    validateAndContinue(function () {
      bypassForms.add(form);
      form.requestSubmit(button || undefined);
    });
  }, true);

  document.addEventListener('click', function (event) {
    const link = event.target.closest('a[href]');
    if (!link || !isCheckout(link.getAttribute('href'))) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    validateAndContinue(function () { window.location.assign(link.href); });
  }, true);

  window.cfConeIntegrity = {
    missingCones: missingCones,
    prepareCart: function () { validateAndContinue(function () {}); }
  };
  if (document.body.classList.contains('template-cart')) window.cfConeIntegrity.prepareCart();
})();
